import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GROUPS_FEATURE_KEY, EntraIdGroupsState } from '../reducers/entra-id-groups.reducer';
import {
  SECURITY_GROUP_ADMIN,
  SECURITY_GROUP_BASIC,
  SECURITY_GROUP_KPI_READER,
  SECURITY_GROUP_AI_USER,
  SECURITY_GROUP_AI_ADMIN,
  SECURITY_GROUP_KPI_KEY_USER,
} from '../../services/entra-id.service';

export const getEntraIdGroupsState = createFeatureSelector<EntraIdGroupsState>(GROUPS_FEATURE_KEY);

export const getGroupsEntities = createSelector(getEntraIdGroupsState, state => state.entities);

export const getGroups = createSelector(getGroupsEntities, entities => {
  return Object.keys(entities).map(id => entities[id]);
});

export const isUserAuthorized = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_BASIC];
});

export const isUserAdmin = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_ADMIN];
});

export const isUserKpiReader = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_KPI_READER];
});

export const isUserAiUser = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_AI_USER];
});

export const isUserAiAdmin = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_AI_ADMIN];
});

export const isUserKpiKeyUser = createSelector(getGroupsEntities, entities => {
  return !!entities[SECURITY_GROUP_KPI_KEY_USER];
});

export const getGroupsLoaded = createSelector(getEntraIdGroupsState, state => state.loaded);

export const getGroupsLoading = createSelector(getEntraIdGroupsState, state => state.loading);
